(self["webpackChunkshine_on"] = self["webpackChunkshine_on"] || []).push([[412],{

/***/ 412:
/***/ (function(module) {

!function (t, e) {
   true ? module.exports = e() : 0;
}(window, function () {
  return i = {}, o.m = n = [function (t, e, n) {
    var i = n(7);
    "string" == typeof i && (i = [[t.i, i, ""]]), i.locals && (t.exports = i.locals);
    (0, n(4).default)("d763679c", i, !1, {});
  }, function (t, e, n) {
    var i = n(10);
    "string" == typeof i && (i = [[t.i, i, ""]]), i.locals && (t.exports = i.locals);
    (0, n(4).default)("6b9cc0e0", i, !1, {});
  }, function (t, e, n) {
    var i = n(12);
    "string" == typeof i && (i = [[t.i, i, ""]]), i.locals && (t.exports = i.locals);
    (0, n(4).default)("663c004e", i, !1, {});
  }, function (t, e) {
    t.exports = function (n) {
      var s = [];
      return s.toString = function () {
        return this.map(function (t) {
          var e = function (t, e) {
            var n = t[1] || "",
                i = t[3];
            if (!i) return n;

            if (e && "function" == typeof btoa) {
              var o = function (t) {
                return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(t)))) + " */";
              }(i),
                  r = i.sources.map(function (t) {
                return "/*# sourceURL=" + i.sourceRoot + t + " */";
              });

              return [n].concat(r).concat([o]).join("\n");
            }

            return [n].join("\n");
          }(t, n);

          return t[2] ? "@media " + t[2] + "{" + e + "}" : e;
        }).join("");
      }, s.i = function (t, e) {
        "string" == typeof t && (t = [[null, t, ""]]);

        for (var n = {}, i = 0; i < this.length; i++) {
          var o = this[i][0];
          "number" == typeof o && (n[o] = !0);
        }

        for (i = 0; i < t.length; i++) {
          var r = t[i];
          "number" == typeof r[0] && n[r[0]] || (e && !r[2] ? r[2] = e : e && (r[2] = "(" + r[2] + ") and (" + e + ")"), s.push(r));
        }
      }, s;
    };
  }, function (t, e, n) {
    "use strict";

    function l(t, e) {
      for (var n = [], i = {}, o = 0; o < e.length; o++) {
        var r = e[o],
            s = r[0],
            a = {
          id: t + ":" + o,
          css: r[1],
          media: r[2],
          sourceMap: r[3]
        };
        i[s] ? i[s].parts.push(a) : n.push(i[s] = {
          id: s,
          parts: [a]
        });
      }

      return n;
    }

    n.r(e), n.d(e, "default", function () {
      return v;
    });
    var i = "undefined" != typeof document;
    if ("undefined" != typeof DEBUG && DEBUG && !i) throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");

    var u = {},
        o = i && (document.head || document.getElementsByTagName("head")[0]),
        r = null,
        s = 0,
        c = !1,
        a = function () {},
        d = null,
        h = "data-vue-ssr-id",
        f = "undefined" != typeof navigator && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase());

    function v(s, t, e, n) {
      c = e, d = n || {};
      var a = l(s, t);
      return p(a), function (t) {
        for (var e = [], n = 0; n < a.length; n++) {
          var i = a[n];
          (o = u[i.id]).refs--, e.push(o);
        }

        t ? p(a = l(s, t)) : a = [];

        for (n = 0; n < e.length; n++) {
          var o;

          if (0 === (o = e[n]).refs) {
            for (var r = 0; r < o.parts.length; r++) o.parts[r]();

            delete u[o.id];
          }
        }
      };
    }

    function p(t) {
      for (var e = 0; e < t.length; e++) {
        var n = t[e],
            i = u[n.id];

        if (i) {
          i.refs++;

          for (var o = 0; o < i.parts.length; o++) i.parts[o](n.parts[o]);

          for (; o < n.parts.length; o++) i.parts.push(b(n.parts[o]));

          i.parts.length > n.parts.length && (i.parts.length = n.parts.length);
        } else {
          var r = [];

          for (o = 0; o < n.parts.length; o++) r.push(b(n.parts[o]));

          u[n.id] = {
            id: n.id,
            refs: 1,
            parts: r
          };
        }
      }
    }

    function m() {
      var t = document.createElement("style");
      return t.type = "text/css", o.appendChild(t), t;
    }

    function b(e) {
      var n,
          i,
          t = document.querySelector("style[" + h + '~="' + e.id + '"]');

      if (t) {
        if (c) return a;
        t.parentNode.removeChild(t);
      }

      if (f) {
        var o = s++;
        t = r = r || m(), n = w.bind(null, t, o, !1), i = w.bind(null, t, o, !0);
      } else t = m(), n = function (t, e) {
        var n = e.css,
            i = e.media,
            o = e.sourceMap;
        i && t.setAttribute("media", i);
        d.ssrId && t.setAttribute(h, e.id);
        o && (n += "\n/*# sourceURL=" + o.sources[0] + " */", n += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
        if (t.styleSheet) t.styleSheet.cssText = n;else {
          for (; t.firstChild;) t.removeChild(t.firstChild);

          t.appendChild(document.createTextNode(n));
        }
      }.bind(null, t), i = function () {
        t.parentNode.removeChild(t);
      };

      return n(e), function (t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          n(e = t);
        } else i();
      };
    }

    var g,
        y = (g = [], function (t, e) {
      return g[t] = e, g.filter(Boolean).join("\n");
    });

    function w(t, e, n, i) {
      var o = n ? "" : i.css;
      if (t.styleSheet) t.styleSheet.cssText = y(e, o);else {
        var r = document.createTextNode(o),
            s = t.childNodes;
        s[e] && t.removeChild(s[e]), s.length ? t.insertBefore(r, s[e]) : t.appendChild(r);
      }
    }
  }, function (t, z, e) {
    "use strict";

    (function (t) {
      var i = function () {
        if ("undefined" != typeof Map) return Map;

        function i(t, n) {
          var i = -1;
          return t.some(function (t, e) {
            return t[0] === n && (i = e, !0);
          }), i;
        }

        return Object.defineProperty(t.prototype, "size", {
          get: function () {
            return this.__entries__.length;
          },
          enumerable: !0,
          configurable: !0
        }), t.prototype.get = function (t) {
          var e = i(this.__entries__, t),
              n = this.__entries__[e];
          return n && n[1];
        }, t.prototype.set = function (t, e) {
          var n = i(this.__entries__, t);
          ~n ? this.__entries__[n][1] = e : this.__entries__.push([t, e]);
        }, t.prototype.delete = function (t) {
          var e = this.__entries__,
              n = i(e, t);
          ~n && e.splice(n, 1);
        }, t.prototype.has = function (t) {
          return !!~i(this.__entries__, t);
        }, t.prototype.clear = function () {
          this.__entries__.splice(0);
        }, t.prototype.forEach = function (t, e) {
          void 0 === e && (e = null);

          for (var n = 0, i = this.__entries__; n < i.length; n++) {
            var o = i[n];
            t.call(e, o[1], o[0]);
          }
        }, t;

        function t() {
          this.__entries__ = [];
        }
      }(),
          n = "undefined" != typeof window && "undefined" != typeof document && window.document === document,
          e = void 0 !== t && t.Math === Math ? t : "undefined" != typeof self && self.Math === Math ? self : "undefined" != typeof window && window.Math === Math ? window : Function("return this")(),
          l = "function" == typeof requestAnimationFrame ? requestAnimationFrame.bind(e) : function (t) {
        return setTimeout(function () {
          return t(Date.now());
        }, 1e3 / 60);
      },
          u = 2;

      var o = ["top", "right", "bottom", "left", "width", "height", "size", "weight"],
          r = "undefined" != typeof MutationObserver,
          s = (a.prototype.addObserver = function (t) {
        ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
      }, a.prototype.removeObserver = function (t) {
        var e = this.observers_,
            n = e.indexOf(t);
        ~n && e.splice(n, 1), !e.length && this.connected_ && this.disconnect_();
      }, a.prototype.refresh = function () {
        this.updateObservers_() && this.refresh();
      }, a.prototype.updateObservers_ = function () {
        var t = this.observers_.filter(function (t) {
          return t.gatherActive(), t.hasActive();
        });
        return t.forEach(function (t) {
          return t.broadcastActive();
        }), 0 < t.length;
      }, a.prototype.connect_ = function () {
        n && !this.connected_ && (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), r ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
          attributes: !0,
          childList: !0,
          characterData: !0,
          subtree: !0
        })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
      }, a.prototype.disconnect_ = function () {
        n && this.connected_ && (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
      }, a.prototype.onTransitionEnd_ = function (t) {
        var e = t.propertyName,
            n = void 0 === e ? "" : e;
        o.some(function (t) {
          return !!~n.indexOf(t);
        }) && this.refresh();
      }, a.getInstance = function () {
        return this.instance_ || (this.instance_ = new a()), this.instance_;
      }, a.instance_ = null, a);

      function a() {
        function t() {
          r && (r = !1, i()), s && n();
        }

        function e() {
          l(t);
        }

        function n() {
          var t = Date.now();

          if (r) {
            if (t - a < u) return;
            s = !0;
          } else s = !(r = !0), setTimeout(e, o);

          a = t;
        }

        var i, o, r, s, a;
        this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = (i = this.refresh.bind(this), s = r = !(o = 20), a = 0, n);
      }

      var c = function (t, e) {
        for (var n = 0, i = Object.keys(e); n < i.length; n++) {
          var o = i[n];
          Object.defineProperty(t, o, {
            value: e[o],
            enumerable: !1,
            writable: !1,
            configurable: !0
          });
        }

        return t;
      },
          h = function (t) {
        return t && t.ownerDocument && t.ownerDocument.defaultView || e;
      },
          f = g(0, 0, 0, 0);

      function v(t) {
        return parseFloat(t) || 0;
      }

      function p(n) {
        for (var t = [], e = 1; e < arguments.length; e++) t[e - 1] = arguments[e];

        return t.reduce(function (t, e) {
          return t + v(n["border-" + e + "-width"]);
        }, 0);
      }

      function d(t) {
        var e = t.clientWidth,
            n = t.clientHeight;
        if (!e && !n) return f;

        var i,
            o = h(t).getComputedStyle(t),
            r = function (t) {
          for (var e = {}, n = 0, i = ["top", "right", "bottom", "left"]; n < i.length; n++) {
            var o = i[n],
                r = t["padding-" + o];
            e[o] = v(r);
          }

          return e;
        }(o),
            s = r.left + r.right,
            a = r.top + r.bottom,
            l = v(o.width),
            u = v(o.height);

        if ("border-box" === o.boxSizing && (Math.round(l + s) !== e && (l -= p(o, "left", "right") + s), Math.round(u + a) !== n && (u -= p(o, "top", "bottom") + a)), (i = t) !== h(i).document.documentElement) {
          var c = Math.round(l + s) - e,
              d = Math.round(u + a) - n;
          1 !== Math.abs(c) && (l -= c), 1 !== Math.abs(d) && (u -= d);
        }

        return g(r.left, r.top, l, u);
      }

      var m = "undefined" != typeof SVGGraphicsElement ? function (t) {
        return t instanceof h(t).SVGGraphicsElement;
      } : function (t) {
        return t instanceof h(t).SVGElement && "function" == typeof t.getBBox;
      };

      function b(t) {
        return n ? m(t) ? g(0, 0, (e = t.getBBox()).width, e.height) : d(t) : f;
        var e;
      }

      function g(t, e, n, i) {
        return {
          x: t,
          y: e,
          width: n,
          height: i
        };
      }

      var y = (w.prototype.isActive = function () {
        var t = b(this.target);
        return (this.contentRect_ = t).width !== this.broadcastWidth || t.height !== this.broadcastHeight;
      }, w.prototype.broadcastRect = function () {
        var t = this.contentRect_;
        return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
      }, w);

      function w(t) {
        this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = g(0, 0, 0, 0), this.target = t;
      }

      var _ = function (t, e) {
        var n,
            i,
            o,
            r,
            s,
            a,
            l,
            u = (i = (n = e).x, o = n.y, r = n.width, s = n.height, a = "undefined" != typeof DOMRectReadOnly ? DOMRectReadOnly : Object, l = Object.create(a.prototype), c(l, {
          x: i,
          y: o,
          width: r,
          height: s,
          top: o,
          right: i + r,
          bottom: s + o,
          left: i
        }), l);
        c(this, {
          target: t,
          contentRect: u
        });
      },
          E = (x.prototype.observe = function (t) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");

        if ("undefined" != typeof Element && Element instanceof Object) {
          if (!(t instanceof h(t).Element)) throw new TypeError('parameter 1 is not of type "Element".');
          var e = this.observations_;
          e.has(t) || (e.set(t, new y(t)), this.controller_.addObserver(this), this.controller_.refresh());
        }
      }, x.prototype.unobserve = function (t) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");

        if ("undefined" != typeof Element && Element instanceof Object) {
          if (!(t instanceof h(t).Element)) throw new TypeError('parameter 1 is not of type "Element".');
          var e = this.observations_;
          e.has(t) && (e.delete(t), e.size || this.controller_.removeObserver(this));
        }
      }, x.prototype.disconnect = function () {
        this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
      }, x.prototype.gatherActive = function () {
        var e = this;
        this.clearActive(), this.observations_.forEach(function (t) {
          t.isActive() && e.activeObservations_.push(t);
        });
      }, x.prototype.broadcastActive = function () {
        if (this.hasActive()) {
          var t = this.callbackCtx_,
              e = this.activeObservations_.map(function (t) {
            return new _(t.target, t.broadcastRect());
          });
          this.callback_.call(t, e, t), this.clearActive();
        }
      }, x.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
      }, x.prototype.hasActive = function () {
        return 0 < this.activeObservations_.length;
      }, x);

      function x(t, e, n) {
        if (this.activeObservations_ = [], this.observations_ = new i(), "function" != typeof t) throw new TypeError("The callback provided as parameter 1 is not a function.");
        this.callback_ = t, this.controller_ = e, this.callbackCtx_ = n;
      }

      var T = new ("undefined" != typeof WeakMap ? WeakMap : i)(),
          O = function t(e) {
        if (!(this instanceof t)) throw new TypeError("Cannot call a class as a function.");
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        var n = s.getInstance(),
            i = new E(e, n, this);
        T.set(this, i);
      };

      ["observe", "unobserve", "disconnect"].forEach(function (e) {
        O.prototype[e] = function () {
          var t;
          return (t = T.get(this))[e].apply(t, arguments);
        };
      });
      var S = void 0 !== e.ResizeObserver ? e.ResizeObserver : O;
      z.a = S;
    }).call(this, e(8));
  }, function (t, e, n) {
    "use strict";

    var i = n(0);
    n.n(i).a;
  }, function (t, e, n) {
    (t.exports = n(3)(!1)).push([t.i, "\n.vue-modal-top,\n.vue-modal-bottom,\n.vue-modal-left,\n.vue-modal-right,\n.vue-modal-topRight,\n.vue-modal-topLeft,\n.vue-modal-bottomLeft,\n.vue-modal-bottomRight {\n  display: block;\n  overflow: hidden;\n  position: absolute;\n  background: transparent;\n  z-index: 9999999;\n}\n.vue-modal-topRight,\n.vue-modal-topLeft,\n.vue-modal-bottomLeft,\n.vue-modal-bottomRight {\n  width: 12px;\n  height: 12px;\n}\n.vue-modal-top {\n  right: 12;\n  top: 0;\n  width: 100%;\n  height: 12px;\n  cursor: n-resize;\n}\n.vue-modal-bottom {\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 12px;\n  cursor: s-resize;\n}\n.vue-modal-left {\n  left: 0;\n  top: 0;\n  width: 12px;\n  height: 100%;\n  cursor: w-resize;\n}\n.vue-modal-right {\n  right: 0;\n  top: 0;\n  width: 12px;\n  height: 100%;\n  cursor: e-resize;\n}\n.vue-modal-topRight {\n  right: 0;\n  top: 0;\n  background: transparent;\n  cursor: ne-resize;\n}\n.vue-modal-topLeft {\n  left: 0;\n  top: 0;\n  cursor: nw-resize;\n}\n.vue-modal-bottomLeft {\n  left: 0;\n  bottom: 0;\n  cursor: sw-resize;\n}\n.vue-modal-bottomRight {\n  right: 0;\n  bottom: 0;\n  cursor: se-resize;\n}\n#vue-modal-triangle::after {\n  display: block;\n  position: absolute;\n  content: '';\n  background: transparent;\n  left: 0;\n  top: 0;\n  width: 0;\n  height: 0;\n  border-bottom: 10px solid #ddd;\n  border-left: 10px solid transparent;\n}\n#vue-modal-triangle.clicked::after {\n  border-bottom: 10px solid #369be9;\n}\n", ""]);
  }, function (t, e) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (n = window);
    }

    t.exports = n;
  }, function (t, e, n) {
    "use strict";

    var i = n(1);
    n.n(i).a;
  }, function (t, e, n) {
    (t.exports = n(3)(!1)).push([t.i, "\n.vm--block-scroll {\n  overflow: hidden;\n  width: 100vw;\n}\n.vm--container {\n  position: fixed;\n  box-sizing: border-box;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100vh;\n  z-index: 999;\n}\n.vm--overlay {\n  position: fixed;\n  box-sizing: border-box;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.2);\n  /* z-index: 999; */\n  opacity: 1;\n}\n.vm--container.scrollable {\n  height: 100%;\n  min-height: 100vh;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n.vm--modal {\n  position: relative;\n  overflow: hidden;\n  box-sizing: border-box;\n\n  background-color: white;\n  border-radius: 3px;\n  box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);\n}\n.vm--container.scrollable .vm--modal {\n  margin-bottom: 2px;\n}\n.vm--top-right-slot {\n  display: block;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.vm-transition--overlay-enter-active,\n.vm-transition--overlay-leave-active {\n  transition: all 50ms;\n}\n.vm-transition--overlay-enter,\n.vm-transition--overlay-leave-active {\n  opacity: 0;\n}\n.vm-transition--modal-enter-active,\n.vm-transition--modal-leave-active {\n  transition: all 400ms;\n}\n.vm-transition--modal-enter,\n.vm-transition--modal-leave-active {\n  opacity: 0;\n  transform: translateY(-20px);\n}\n.vm-transition--default-enter-active,\n.vm-transition--default-leave-active {\n  transition: all 2ms;\n}\n.vm-transition--default-enter,\n.vm-transition--default-leave-active {\n  opacity: 0;\n}\n", ""]);
  }, function (t, e, n) {
    "use strict";

    var i = n(2);
    n.n(i).a;
  }, function (t, e, n) {
    (t.exports = n(3)(!1)).push([t.i, "\n.vue-dialog {\n  font-size: 14px;\n}\n.vue-dialog div {\n  box-sizing: border-box;\n}\n.vue-dialog-content {\n  flex: 1 0 auto;\n  width: 100%;\n  padding: 14px;\n}\n.vue-dialog-content-title {\n  font-weight: 600;\n  padding-bottom: 14px;\n}\n.vue-dialog-buttons {\n  display: flex;\n  flex: 0 1 auto;\n  width: 100%;\n  border-top: 1px solid #eee;\n}\n.vue-dialog-buttons-none {\n  width: 100%;\n  padding-bottom: 14px;\n}\n.vue-dialog-button {\n  font-size: inherit;\n  background: transparent;\n  padding: 0;\n  margin: 0;\n  border: 0;\n  cursor: pointer;\n  box-sizing: border-box;\n  line-height: 40px;\n  height: 40px;\n  color: inherit;\n  font: inherit;\n  outline: none;\n}\n.vue-dialog-button:hover {\n  background: #f9f9f9;\n}\n.vue-dialog-button:active {\n  background: #f3f3f3;\n}\n.vue-dialog-button:not(:first-of-type) {\n  border-left: 1px solid #eee;\n}\n", ""]);
  }, function (t, e, n) {
    "use strict";

    n.r(e), n.d(e, "Modal", function () {
      return W;
    }), n.d(e, "Dialog", function () {
      return X;
    }), n.d(e, "version", function () {
      return J;
    });

    function i() {
      var e = this,
          t = e.$createElement,
          n = e._self._c || t;
      return e.visible ? n("div", {
        class: e.containerClass
      }, [n("transition", {
        attrs: {
          name: e.guaranteedOverlayTransition
        },
        on: {
          "before-enter": e.beforeOverlayTransitionEnter,
          "after-enter": e.afterOverlayTransitionEnter,
          "before-leave": e.beforeOverlayTransitionLeave,
          "after-leave": e.afterOverlayTransitionLeave
        }
      }, [e.visibility.overlay ? n("div", {
        staticClass: "vm--overlay",
        attrs: {
          "data-modal": e.name,
          "aria-expanded": e.visibility.overlay.toString()
        },
        on: {
          click: function (t) {
            return t.target !== t.currentTarget ? null : (t.stopPropagation(), e.onOverlayClick(t));
          }
        }
      }, [n("div", {
        staticClass: "vm--top-right-slot"
      }, [e._t("top-right")], 2)]) : e._e()]), e._v(" "), n("transition", {
        attrs: {
          name: e.guaranteedModalTransition
        },
        on: {
          "before-enter": e.beforeModalTransitionEnter,
          "after-enter": e.afterModalTransitionEnter,
          "before-leave": e.beforeModalTransitionLeave,
          "after-leave": e.afterModalTransitionLeave
        }
      }, [e.visibility.modal ? n("div", {
        ref: "modal",
        class: e.modalClass,
        style: e.modalStyle,
        attrs: {
          "aria-expanded": e.visibility.modal.toString(),
          role: "dialog",
          "aria-modal": "true"
        }
      }, [e._t("default"), e._v(" "), e.resizable && !e.isAutoHeight ? n("resizer", {
        attrs: {
          "min-width": e.minWidth,
          "min-height": e.minHeight,
          "max-width": e.maxWidth,
          "max-height": e.maxHeight,
          "viewport-height": e.viewportHeight,
          "viewport-width": e.viewportWidth,
          "resize-indicator": e.resizeIndicator,
          "resize-edges": e.resizeEdges
        },
        on: {
          resize: e.onModalResize
        }
      }) : e._e()], 2) : e._e()])], 1) : e._e();
    }

    function o() {
      var t = this,
          e = t.$createElement,
          n = t._self._c || e;
      return n("div", [this.resizeEdges.includes("t") ? n("div", {
        staticClass: "vue-modal-top"
      }) : t._e(), t._v(" "), this.resizeEdges.includes("b") ? n("div", {
        staticClass: "vue-modal-bottom"
      }) : t._e(), t._v(" "), this.resizeEdges.includes("l") ? n("div", {
        staticClass: "vue-modal-left"
      }) : t._e(), t._v(" "), this.resizeEdges.includes("r") ? n("div", {
        staticClass: "vue-modal-right"
      }) : t._e(), t._v(" "), this.resizeEdges.includes("tr") ? n("div", {
        staticClass: "vue-modal-topRight"
      }) : t._e(), t._v(" "), this.resizeEdges.includes("tl") ? n("div", {
        staticClass: "vue-modal-topLeft"
      }) : t._e(), t._v(" "), this.resizeEdges.includes("br") ? n("div", {
        class: t.className,
        attrs: {
          id: t.getID
        }
      }) : t._e(), t._v(" "), this.resizeEdges.includes("bl") ? n("div", {
        staticClass: "vue-modal-bottomLeft"
      }) : t._e()]);
    }

    o._withStripped = i._withStripped = !0;

    function h(t, e, n) {
      return n < t ? t : e < n ? e : n;
    }

    function r(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    function s(t, e) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, e) {
        var n = [],
            i = !0,
            o = !1,
            r = void 0;

        try {
          for (var s, a = t[Symbol.iterator](); !(i = (s = a.next()).done) && (n.push(s.value), !e || n.length !== e); i = !0);
        } catch (t) {
          o = !0, r = t;
        } finally {
          try {
            i || null == a.return || a.return();
          } finally {
            if (o) throw r;
          }
        }

        return n;
      }(t, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    function u() {
      var t = window.innerWidth,
          e = document.documentElement.clientWidth;
      return t && e ? Math.min(t, e) : e || t;
    }

    function a(t) {
      return t.split(";").map(function (t) {
        return t.trim();
      }).filter(Boolean).map(function (t) {
        return t.split(":");
      }).reduce(function (t, e) {
        var n = s(e, 2);
        return function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {},
                i = Object.keys(n);
            "function" == typeof Object.getOwnPropertySymbols && (i = i.concat(Object.getOwnPropertySymbols(n).filter(function (t) {
              return Object.getOwnPropertyDescriptor(n, t).enumerable;
            }))), i.forEach(function (t) {
              r(e, t, n[t]);
            });
          }

          return e;
        }({}, t, r({}, n[0], n[1]));
      }, {});
    }

    function f(t) {
      return t.touches && 0 < t.touches.length ? t.touches[0] : t;
    }

    var v = ["INPUT", "TEXTAREA", "SELECT"],
        c = function (t) {
      var e = 0 < arguments.length && void 0 !== t ? t : 0;
      return function () {
        return (e++).toString();
      };
    }(),
        l = {
      name: "VueJsModalResizer",
      props: {
        minHeight: {
          type: Number,
          default: 0
        },
        minWidth: {
          type: Number,
          default: 0
        },
        maxWidth: {
          type: Number,
          default: Number.MAX_SAFE_INTEGER
        },
        maxHeight: {
          type: Number,
          default: Number.MAX_SAFE_INTEGER
        },
        viewportWidth: {
          type: Number,
          required: !0
        },
        viewportHeight: {
          type: Number,
          required: !0
        },
        resizeIndicator: {
          type: Boolean,
          default: !0
        },
        resizeEdges: {
          type: Array,
          required: !0
        }
      },
      data: function () {
        return {
          clicked: !1,
          targetClass: "",
          size: {},
          initialX: 0,
          initialY: 0
        };
      },
      mounted: function () {
        this.$el.addEventListener("mousedown", this.start, !1);
      },
      computed: {
        className: function () {
          return ["vue-modal-bottomRight", {
            clicked: this.clicked
          }];
        },
        getID: function () {
          return this.resizeIndicator ? "vue-modal-triangle" : "";
        }
      },
      methods: {
        start: function (t) {
          this.targetClass = t.target.className, this.clicked = !0, this.initialX = t.clientX, this.initialY = t.clientY, window.addEventListener("mousemove", this.mousemove, !1), window.addEventListener("mouseup", this.stop, !1), t.stopPropagation(), t.preventDefault();
        },
        stop: function () {
          this.clicked = !1, this.clicked = !1, this.targetClass = "", this.initialX = 0, this.initialY = 0, window.removeEventListener("mousemove", this.mousemove, !1), window.removeEventListener("mouseup", this.stop, !1), this.$emit("resize-stop", {
            element: this.$el.parentElement,
            size: this.size
          });
        },
        mousemove: function (t) {
          this.resize(t);
        },
        resize: function (t) {
          var e = this.$el.parentElement,
              n = t.clientX,
              i = t.clientY,
              o = parseInt(e.style.width.replace("px", "")),
              r = parseInt(e.style.height.replace("px", ""));

          if (!(t.clientX > this.viewportWidth || t.clientX < 0) && !(t.clientY > this.viewportHeight || t.clientY < 0) && e) {
            switch (this.targetClass) {
              case "vue-modal-right":
                n -= e.offsetLeft, i = r;
                break;

              case "vue-modal-left":
                i = r, n = o + (this.initialX - t.clientX);
                break;

              case "vue-modal-top":
                n = o, i = r + (this.initialY - t.clientY);
                break;

              case "vue-modal-bottom":
                n = o, i -= e.offsetTop;
                break;

              case "vue-modal-bottomRight":
                n -= e.offsetLeft, i -= e.offsetTop;
                break;

              case "vue-modal-topRight":
                n -= e.offsetLeft, i = r + (this.initialY - t.clientY);
                break;

              case "vue-modal-bottomLeft":
                n = o + (this.initialX - t.clientX), i -= e.offsetTop;
                break;

              case "vue-modal-topLeft":
                n = o + (this.initialX - t.clientX), i = r + (this.initialY - t.clientY);
                break;

              default:
                console.error("Incorrrect/no resize direction.");
            }

            var s = Math.min(u(), this.maxWidth),
                a = Math.min(window.innerHeight, this.maxHeight);
            n = h(this.minWidth, s, n), i = h(this.minHeight, a, i), this.initialX = t.clientX, this.initialY = t.clientY, this.size = {
              width: n,
              height: i
            };
            var l = {
              width: n - o,
              height: i - r
            };
            e.style.width = n + "px", e.style.height = i + "px", this.$emit("resize", {
              element: e,
              size: this.size,
              direction: this.targetClass,
              dimGrowth: l
            });
          }
        }
      }
    };

    n(6);

    function d(t, e, n, i, o, r, s, a) {
      var l,
          u = "function" == typeof t ? t.options : t;
      if (e && (u.render = e, u.staticRenderFns = n, u._compiled = !0), i && (u.functional = !0), r && (u._scopeId = "data-v-" + r), s ? (l = function (t) {
        (t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) || "undefined" == typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__), o && o.call(this, t), t && t._registeredComponents && t._registeredComponents.add(s);
      }, u._ssrRegister = l) : o && (l = a ? function () {
        o.call(this, this.$root.$options.shadowRoot);
      } : o), l) if (u.functional) {
        u._injectStyles = l;
        var c = u.render;

        u.render = function (t, e) {
          return l.call(e), c(t, e);
        };
      } else {
        var d = u.beforeCreate;
        u.beforeCreate = d ? [].concat(d, l) : [l];
      }
      return {
        exports: t,
        options: u
      };
    }

    var p = d(l, o, [], !1, null, null, null);
    p.options.__file = "src/components/Resizer.vue";
    var m = p.exports;

    function b(t) {
      return (b = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function g(t) {
      switch (b(t)) {
        case "number":
          return {
            type: "px",
            value: t
          };

        case "string":
          return function (e) {
            if ("auto" === e) return {
              type: e,
              value: 0
            };

            var t = _.find(function (t) {
              return t.regexp.test(e);
            });

            return t ? {
              type: t.name,
              value: parseFloat(e)
            } : {
              type: "",
              value: e
            };
          }(t);

        default:
          return {
            type: "",
            value: t
          };
      }
    }

    function y(t) {
      if ("string" != typeof t) return 0 <= t;
      var e = g(t);
      return ("%" === e.type || "px" === e.type) && 0 < e.value;
    }

    var w = "[-+]?[0-9]*.?[0-9]+",
        _ = [{
      name: "px",
      regexp: new RegExp("^".concat(w, "px$"))
    }, {
      name: "%",
      regexp: new RegExp("^".concat(w, "%$"))
    }, {
      name: "px",
      regexp: new RegExp("^".concat(w, "$"))
    }],
        E = n(5),
        x = "undefined" != typeof window && window.ResizeObserver ? ResizeObserver : E.a;

    function T(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }

    function O(t) {
      return function (t) {
        if (Array.isArray(t)) {
          for (var e = 0, n = new Array(t.length); e < t.length; e++) n[e] = t[e];

          return n;
        }
      }(t) || function (t) {
        if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
      }(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }

    function S(t) {
      return e = 'button:not([disabled]), select:not([disabled]), a[href]:not([disabled]), area[href]:not([disabled]), [contentEditable=""]:not([disabled]), [contentEditable="true"]:not([disabled]), [contentEditable="TRUE"]:not([disabled]), textarea:not([disabled]), iframe:not([disabled]), input:not([disabled]), summary:not([disabled]), [tabindex]:not([tabindex="-1"])', O(t.querySelectorAll(e) || []);
      var e;
    }

    function z(t) {
      return t == document.activeElement;
    }

    var M = function () {
      function t() {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.root = null, this.elements = [], this.onKeyDown = this.onKeyDown.bind(this), this.enable = this.enable.bind(this), this.disable = this.disable.bind(this), this.firstElement = this.firstElement.bind(this), this.lastElement = this.lastElement.bind(this);
      }

      var e, n, i;
      return e = t, (n = [{
        key: "lastElement",
        value: function () {
          return this.elements[this.elements.length - 1] || null;
        }
      }, {
        key: "firstElement",
        value: function () {
          return this.elements[0] || null;
        }
      }, {
        key: "onKeyDown",
        value: function (t) {
          var e;
          if ("Tab" === (e = t).key || 9 === e.keyCode) return t.shiftKey && z(this.firstElement()) ? (this.lastElement().focus(), void t.preventDefault()) : !document.activeElement || z(this.lastElement()) ? (this.firstElement().focus(), void t.preventDefault()) : void 0;
        }
      }, {
        key: "enabled",
        value: function () {
          return !!this.root;
        }
      }, {
        key: "enable",
        value: function (t) {
          if (t) {
            this.root = t, this.elements = S(this.root);
            var e = this.firstElement();
            e && e.focus(), this.root.addEventListener("keydown", this.onKeyDown);
          }
        }
      }, {
        key: "disable",
        value: function () {
          this.root.removeEventListener("keydown", this.onKeyDown), this.root = null;
        }
      }]) && T(e.prototype, n), i && T(e, i), t;
    }();

    function L(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    function k(t, e) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, e) {
        var n = [],
            i = !0,
            o = !1,
            r = void 0;

        try {
          for (var s, a = t[Symbol.iterator](); !(i = (s = a.next()).done) && (n.push(s.value), !e || n.length !== e); i = !0);
        } catch (t) {
          o = !0, r = t;
        } finally {
          try {
            i || null == a.return || a.return();
          } finally {
            if (o) throw r;
          }
        }

        return n;
      }(t, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    var R = "vm-transition--default",
        C = "enter",
        $ = "entering",
        A = "leave",
        j = "leavng",
        H = {
      name: "VueJsModal",
      props: {
        name: {
          required: !0,
          type: String
        },
        resizable: {
          type: Boolean,
          default: !1
        },
        resizeEdges: {
          default: function () {
            return ["r", "br", "b", "bl", "l", "tl", "t", "tr"];
          },
          validator: function (e) {
            return ["r", "br", "b", "bl", "l", "tl", "t", "tr"].filter(function (t) {
              return -1 !== e.indexOf(t);
            }).length === e.length;
          },
          type: Array
        },
        centerResize: {
          type: Boolean,
          default: !0
        },
        resizeIndicator: {
          type: Boolean,
          default: !0
        },
        adaptive: {
          type: Boolean,
          default: !1
        },
        draggable: {
          type: [Boolean, String],
          default: !1
        },
        scrollable: {
          type: Boolean,
          default: !1
        },
        focusTrap: {
          type: Boolean,
          default: !1
        },
        reset: {
          type: Boolean,
          default: !1
        },
        overlayTransition: {
          type: String,
          default: "vm-transition--overlay"
        },
        transition: {
          type: String,
          default: "vm-transition--modal"
        },
        clickToClose: {
          type: Boolean,
          default: !0
        },
        classes: {
          type: [String, Array],
          default: function () {
            return [];
          }
        },
        styles: {
          type: [String, Array, Object]
        },
        minWidth: {
          type: Number,
          default: 0,
          validator: function (t) {
            return 0 <= t;
          }
        },
        minHeight: {
          type: Number,
          default: 0,
          validator: function (t) {
            return 0 <= t;
          }
        },
        maxWidth: {
          type: Number,
          default: Number.MAX_SAFE_INTEGER
        },
        maxHeight: {
          type: Number,
          default: Number.MAX_SAFE_INTEGER
        },
        width: {
          type: [Number, String],
          default: 600,
          validator: function (t) {
            return "auto" === t || y(t);
          }
        },
        height: {
          type: [Number, String],
          default: 300,
          validator: function (t) {
            return "auto" === t || y(t);
          }
        },
        shiftX: {
          type: Number,
          default: .5,
          validator: function (t) {
            return 0 <= t && t <= 1;
          }
        },
        shiftY: {
          type: Number,
          default: .5,
          validator: function (t) {
            return 0 <= t && t <= 1;
          }
        }
      },
      components: {
        Resizer: m
      },
      data: function () {
        return {
          visible: !1,
          visibility: {
            modal: !1,
            overlay: !1
          },
          overlayTransitionState: null,
          modalTransitionState: null,
          shiftLeft: 0,
          shiftTop: 0,
          modal: {
            width: 0,
            widthType: "px",
            height: 0,
            heightType: "px",
            renderedHeight: 0
          },
          viewportHeight: 0,
          viewportWidth: 0
        };
      },
      created: function () {
        this.setInitialSize();
      },
      beforeMount: function () {
        this.$modal.subscription.$on("toggle", this.onToggle), window.addEventListener("resize", this.onWindowResize), window.addEventListener("orientationchange", this.onWindowResize), this.onWindowResize(), this.scrollable && !this.isAutoHeight && console.warn('Modal "'.concat(this.name, '" has scrollable flag set to true ') + 'but height is not "auto" ('.concat(this.height, ")")), this.clickToClose && window.addEventListener("keyup", this.onEscapeKeyUp);
      },
      mounted: function () {
        var n = this;
        this.resizeObserver = new x(function (t) {
          if (0 < t.length) {
            var e = k(t, 1)[0];
            n.modal.renderedHeight = e.contentRect.height;
          }
        }), this.$focusTrap = new M();
      },
      beforeDestroy: function () {
        this.$modal.subscription.$off("toggle", this.onToggle), window.removeEventListener("resize", this.onWindowResize), window.removeEventListener("orientationchange", this.onWindowResize), this.clickToClose && window.removeEventListener("keyup", this.onEscapeKeyUp), document.body.classList.remove("vm--block-scroll");
      },
      computed: {
        guaranteedOverlayTransition: function () {
          return this.overlayTransition || R;
        },
        guaranteedModalTransition: function () {
          return this.transition || R;
        },
        isAutoHeight: function () {
          return "auto" === this.modal.heightType;
        },
        position: function () {
          var t = this.viewportHeight,
              e = this.viewportWidth,
              n = this.shiftLeft,
              i = this.shiftTop,
              o = this.shiftX,
              r = this.shiftY,
              s = this.trueModalWidth,
              a = this.trueModalHeight,
              l = e - s,
              u = Math.max(t - a, 0),
              c = i + r * u;
          return {
            left: parseInt(h(0, l, n + o * l)),
            top: !a && this.isAutoHeight ? void 0 : parseInt(h(0, u, c))
          };
        },
        trueModalWidth: function () {
          var t = this.viewportWidth,
              e = this.modal,
              n = this.adaptive,
              i = this.minWidth,
              o = this.maxWidth,
              r = "%" === e.widthType ? t / 100 * e.width : e.width;

          if (n) {
            var s = Math.max(i, Math.min(t, o));
            return h(i, s, r);
          }

          return r;
        },
        trueModalHeight: function () {
          var t = this.viewportHeight,
              e = this.modal,
              n = this.isAutoHeight,
              i = this.adaptive,
              o = this.minHeight,
              r = this.maxHeight,
              s = "%" === e.heightType ? t / 100 * e.height : e.height;
          if (n) return this.modal.renderedHeight;

          if (i) {
            var a = Math.max(o, Math.min(t, r));
            return h(o, a, s);
          }

          return s;
        },
        autoHeight: function () {
          return this.adaptive && this.modal.renderedHeight >= this.viewportHeight ? Math.max(this.minHeight, this.viewportHeight) + "px" : "auto";
        },
        containerClass: function () {
          return ["vm--container", this.scrollable && this.isAutoHeight && "scrollable"];
        },
        modalClass: function () {
          return ["vm--modal", this.classes];
        },
        stylesProp: function () {
          return "string" == typeof this.styles ? a(this.styles) : this.styles;
        },
        modalStyle: function () {
          return [this.stylesProp, {
            top: this.position.top + "px",
            left: this.position.left + "px",
            width: this.trueModalWidth + "px",
            height: this.isAutoHeight ? this.autoHeight : this.trueModalHeight + "px"
          }];
        },
        isComponentReadyToBeDestroyed: function () {
          return this.overlayTransitionState === A && this.modalTransitionState === A;
        }
      },
      watch: {
        isComponentReadyToBeDestroyed: function (t) {
          t && (this.visible = !1);
        }
      },
      methods: {
        startTransitionEnter: function () {
          this.visibility.overlay = !0, this.visibility.modal = !0;
        },
        startTransitionLeave: function () {
          this.visibility.overlay = !1, this.visibility.modal = !1;
        },
        beforeOverlayTransitionEnter: function () {
          this.overlayTransitionState = $;
        },
        afterOverlayTransitionEnter: function () {
          this.overlayTransitionState = C;
        },
        beforeOverlayTransitionLeave: function () {
          this.overlayTransitionState = j;
        },
        afterOverlayTransitionLeave: function () {
          this.overlayTransitionState = A;
        },
        beforeModalTransitionEnter: function () {
          var t = this;
          this.modalTransitionState = $, this.$nextTick(function () {
            t.resizeObserver.observe(t.$refs.modal);
          });
        },
        afterModalTransitionEnter: function () {
          this.modalTransitionState = C, this.draggable && this.addDraggableListeners(), this.focusTrap && this.$focusTrap.enable(this.$refs.modal);
          var t = this.createModalEvent({
            state: "opened"
          });
          this.$emit("opened", t);
        },
        beforeModalTransitionLeave: function () {
          this.modalTransitionState = j, this.resizeObserver.unobserve(this.$refs.modal), this.$focusTrap.enabled() && this.$focusTrap.disable();
        },
        afterModalTransitionLeave: function () {
          this.modalTransitionState = A;
          var t = this.createModalEvent({
            state: "closed"
          });
          this.$emit("closed", t);
        },
        onToggle: function (t, e, n) {
          if (this.name === t) {
            var i = void 0 === e ? !this.visible : e;
            this.toggle(i, n);
          }
        },
        setInitialSize: function () {
          var t = g(this.width),
              e = g(this.height);
          this.modal.width = t.value, this.modal.widthType = t.type, this.modal.height = e.value, this.modal.heightType = e.type;
        },
        onEscapeKeyUp: function (t) {
          27 === t.which && this.visible && this.$modal.hide(this.name);
        },
        onWindowResize: function () {
          this.viewportWidth = u(), this.viewportHeight = window.innerHeight, this.ensureShiftInWindowBounds();
        },
        createModalEvent: function (t) {
          var e = 0 < arguments.length && void 0 !== t ? t : {};
          return function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {},
                  i = Object.keys(n);
              "function" == typeof Object.getOwnPropertySymbols && (i = i.concat(Object.getOwnPropertySymbols(n).filter(function (t) {
                return Object.getOwnPropertyDescriptor(n, t).enumerable;
              }))), i.forEach(function (t) {
                L(e, t, n[t]);
              });
            }

            return e;
          }({
            name: this.name,
            ref: this.$refs.modal || null
          }, e);
        },
        onModalResize: function (t) {
          this.modal.widthType = "px", this.modal.width = t.size.width, this.modal.heightType = "px", this.modal.height = t.size.height, this.centerResize || (this.shiftLeft = this.getResizedShiftLeft(t), this.shiftTop = this.getResizedShiftTop(t));
          var e = this.modal.size;
          this.$emit("resize", this.createModalEvent({
            size: e
          }));
        },
        getResizedShiftLeft: function (t) {
          this.viewportHeight, this.viewportWidth, this.trueModalWidth, this.trueModalHeight;
          var e = this.shiftLeft;

          switch (t.direction) {
            case "vue-modal-topRight":
            case "vue-modal-bottomRight":
            case "vue-modal-right":
              e += .5 * t.dimGrowth.width;
              break;

            case "vue-modal-bottomLeft":
            case "vue-modal-topLeft":
            case "vue-modal-left":
              e -= .5 * t.dimGrowth.width;
              break;

            case "vue-modal-top":
            case "vue-modal-bottom":
              break;

            default:
              console.error("Could not Find Resize Direction In ShiftLeft");
          }

          return e;
        },
        getResizedShiftTop: function (t) {
          this.viewportHeight, this.viewportWidth, this.trueModalWidth, this.trueModalHeight;
          var e = this.shiftTop;

          switch (t.direction) {
            case "vue-modal-bottom":
            case "vue-modal-bottomRight":
            case "vue-modal-bottomLeft":
              e += .5 * t.dimGrowth.height;
              break;

            case "vue-modal-top":
            case "vue-modal-topRight":
            case "vue-modal-topLeft":
              e -= .5 * t.dimGrowth.height;
              break;

            case "vue-modal-left":
            case "vue-modal-right":
              break;

            default:
              console.error("Could not Find Resize Direction In ShiftTop");
          }

          return e;
        },
        open: function (t) {
          var e = this;
          this.reset && (this.setInitialSize(), this.shiftLeft = 0, this.shiftTop = 0), this.scrollable && document.body.classList.add("vm--block-scroll");
          var n = !1,
              i = this.createModalEvent({
            cancel: function () {
              n = !0;
            },
            state: "before-open",
            params: t
          });
          this.$emit("before-open", i), n ? this.scrollable && document.body.classList.remove("vm--block-scroll") : ("undefined" != typeof document && document.activeElement && "BODY" !== document.activeElement.tagName && document.activeElement.blur && document.activeElement.blur(), this.visible = !0, this.$nextTick(function () {
            e.startTransitionEnter();
          }));
        },
        close: function (t) {
          this.scrollable && document.body.classList.remove("vm--block-scroll");
          var e = !1,
              n = this.createModalEvent({
            cancel: function () {
              e = !0;
            },
            state: "before-close",
            params: t
          });
          this.$emit("before-close", n), e || this.startTransitionLeave();
        },
        toggle: function (t, e) {
          this.visible !== t && (t ? this.open(e) : this.close(e));
        },
        getDraggableElement: function () {
          return !0 === this.draggable ? this.$refs.modal : "string" == typeof this.draggable ? this.$refs.modal.querySelector(this.draggable) : null;
        },
        onOverlayClick: function () {
          this.clickToClose && this.toggle(!1);
        },
        addDraggableListeners: function () {
          var s = this,
              t = this.getDraggableElement();

          if (t) {
            var a = 0,
                l = 0,
                u = 0,
                c = 0,
                e = function (t) {
              var e = t.target;

              if (!(n = e) || -1 === v.indexOf(n.nodeName)) {
                var n,
                    i = f(t),
                    o = i.clientX,
                    r = i.clientY;
                document.addEventListener("mousemove", d), document.addEventListener("touchmove", d), document.addEventListener("mouseup", h), document.addEventListener("touchend", h), a = o, l = r, u = s.shiftLeft, c = s.shiftTop;
              }
            },
                d = function (t) {
              var e = f(t),
                  n = e.clientX,
                  i = e.clientY;
              s.shiftLeft = u + n - a, s.shiftTop = c + i - l, t.preventDefault();
            },
                h = function t(e) {
              s.ensureShiftInWindowBounds(), document.removeEventListener("mousemove", d), document.removeEventListener("touchmove", d), document.removeEventListener("mouseup", t), document.removeEventListener("touchend", t), e.preventDefault();
            };

            t.addEventListener("mousedown", e), t.addEventListener("touchstart", e);
          }
        },
        ensureShiftInWindowBounds: function () {
          var t = this.viewportHeight,
              e = this.viewportWidth,
              n = this.shiftLeft,
              i = this.shiftTop,
              o = this.shiftX,
              r = this.shiftY,
              s = this.trueModalWidth,
              a = this.trueModalHeight,
              l = e - s,
              u = Math.max(t - a, 0),
              c = n + o * l,
              d = i + r * u;
          this.shiftLeft -= c - h(0, l, c), this.shiftTop -= d - h(0, u, d);
        }
      }
    },
        N = (n(9), d(H, i, [], !1, null, null, null));
    N.options.__file = "src/components/Modal.vue";

    function D() {
      var n = this,
          t = n.$createElement,
          i = n._self._c || t;
      return i(n.$modal.context.componentName, {
        tag: "component",
        attrs: {
          name: "dialog",
          height: "auto",
          classes: ["vue-dialog", this.params.class],
          width: n.width,
          "shift-y": .3,
          adaptive: !0,
          "focus-trap": !0,
          clickToClose: n.clickToClose,
          transition: n.transition
        },
        on: {
          "before-open": n.beforeOpened,
          "before-close": n.beforeClosed,
          opened: function (t) {
            return n.$emit("opened", t);
          },
          closed: function (t) {
            return n.$emit("closed", t);
          }
        }
      }, [i("div", {
        staticClass: "vue-dialog-content"
      }, [n.params.title ? i("div", {
        staticClass: "vue-dialog-content-title",
        domProps: {
          innerHTML: n._s(n.params.title || "")
        }
      }) : n._e(), n._v(" "), n.params.component ? i(n.params.component, n._b({
        tag: "component"
      }, "component", n.params.props, !1)) : i("div", {
        domProps: {
          innerHTML: n._s(n.params.text || "")
        }
      })], 1), n._v(" "), n.buttons ? i("div", {
        staticClass: "vue-dialog-buttons"
      }, n._l(n.buttons, function (t, e) {
        return i("button", {
          key: e,
          class: t.class || "vue-dialog-button",
          style: n.buttonStyle,
          attrs: {
            type: "button",
            tabindex: "0"
          },
          domProps: {
            innerHTML: n._s(t.title)
          },
          on: {
            click: function (t) {
              return t.stopPropagation(), n.click(e, t);
            }
          }
        }, [n._v(n._s(t.title))]);
      }), 0) : i("div", {
        staticClass: "vue-dialog-buttons-none"
      })]);
    }

    var W = N.exports;
    D._withStripped = !0;
    var I = {
      name: "VueJsDialog",
      props: {
        width: {
          type: [Number, String],
          default: 400
        },
        clickToClose: {
          type: Boolean,
          default: !0
        },
        transition: {
          type: String
        }
      },
      data: function () {
        return {
          params: {}
        };
      },
      computed: {
        buttons: function () {
          return this.params.buttons || [];
        },
        buttonStyle: function () {
          return {
            flex: "1 1 ".concat(100 / this.buttons.length, "%")
          };
        }
      },
      methods: {
        beforeOpened: function (t) {
          this.params = t.params || {}, this.$emit("before-opened", t);
        },
        beforeClosed: function (t) {
          this.params = {}, this.$emit("before-closed", t);
        },
        click: function (t, e, n) {
          var i = 2 < arguments.length && void 0 !== n ? n : "click",
              o = this.buttons[t],
              r = null == o ? void 0 : o.handler;
          "function" == typeof r && r(t, e, {
            source: i
          });
        }
      }
    },
        P = (n(11), d(I, D, [], !1, null, null, null));
    P.options.__file = "src/components/Dialog.vue";

    function B() {
      var n = this,
          t = n.$createElement,
          i = n._self._c || t;
      return i("div", {
        attrs: {
          id: "modals-container"
        }
      }, n._l(n.modals, function (e) {
        return i("modal", n._g(n._b({
          key: e.id,
          on: {
            closed: function (t) {
              return n.remove(e.id);
            }
          }
        }, "modal", e.modalAttrs, !1), e.modalListeners), [i(e.component, n._g(n._b({
          tag: "component",
          on: {
            close: function (t) {
              return n.$modal.hide(e.modalAttrs.name, t);
            }
          }
        }, "component", e.componentAttrs, !1), n.$listeners))], 1);
      }), 1);
    }

    var X = P.exports;

    function Y(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    B._withStripped = !0;
    var G = d({
      data: function () {
        return {
          modals: []
        };
      },
      created: function () {
        this.$root.__modalContainer = this;
      },
      mounted: function () {
        var t = this;
        this.$modal.subscription.$on("hide-all", function () {
          t.modals = [];
        });
      },
      methods: {
        add: function (t, e, n, i) {
          var o = this,
              r = 1 < arguments.length && void 0 !== e ? e : {},
              s = 2 < arguments.length && void 0 !== n ? n : {},
              a = 3 < arguments.length && void 0 !== i ? i : {},
              l = c(),
              u = s.name || "dynamic_modal_" + l;
          this.modals.push({
            id: l,
            modalAttrs: function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {},
                    i = Object.keys(n);
                "function" == typeof Object.getOwnPropertySymbols && (i = i.concat(Object.getOwnPropertySymbols(n).filter(function (t) {
                  return Object.getOwnPropertyDescriptor(n, t).enumerable;
                }))), i.forEach(function (t) {
                  Y(e, t, n[t]);
                });
              }

              return e;
            }({}, s, {
              name: u
            }),
            modalListeners: a,
            component: t,
            componentAttrs: r
          }), this.$nextTick(function () {
            o.$modal.show(u);
          });
        },
        remove: function (e) {
          var t = this.modals.findIndex(function (t) {
            return t.id === e;
          });
          -1 !== t && this.modals.splice(t, 1);
        }
      }
    }, B, [], !1, null, null, null);
    G.options.__file = "src/components/ModalsContainer.vue";
    var U = G.exports;

    function F(t) {
      return (F = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function q(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    var V = function (i, t) {
      function o(t, e, n, i) {
        var o,
            r = 2 < arguments.length && void 0 !== n ? n : {},
            s = 3 < arguments.length ? i : void 0,
            a = null === (o = c.root) || void 0 === o ? void 0 : o.__modalContainer,
            l = u.dynamicDefaults || {};
        null != a && a.add(t, e, function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {},
                i = Object.keys(n);
            "function" == typeof Object.getOwnPropertySymbols && (i = i.concat(Object.getOwnPropertySymbols(n).filter(function (t) {
              return Object.getOwnPropertyDescriptor(n, t).enumerable;
            }))), i.forEach(function (t) {
              q(e, t, n[t]);
            });
          }

          return e;
        }({}, l, r), s);
      }

      var u = 1 < arguments.length && void 0 !== t ? t : {},
          r = new i(),
          c = {
        root: null,
        componentName: u.componentName || "Modal"
      };
      return {
        context: c,
        subscription: r,
        show: function () {
          for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];

          var i = e[0];

          switch (F(i)) {
            case "string":
              (function (t, e) {
                r.$emit("toggle", t, !0, e);
              }).apply(void 0, e);
              break;

            case "object":
            case "function":
              o.apply(void 0, e);
              break;

            default:
              console.warn("[vue-js-modal] $modal() received an unsupported argument as a first argument.", i);
          }
        },
        hide: function (t, e) {
          r.$emit("toggle", t, !1, e);
        },
        hideAll: function () {
          r.$emit("hide-all");
        },
        toggle: function (t, e) {
          r.$emit("toggle", t, void 0, e);
        },
        setDynamicModalContainer: function (t) {
          c.root = t;
          var e,
              n = (e = document.createElement("div"), document.body.appendChild(e), e);
          new i({
            parent: t,
            render: function (t) {
              return t(U);
            }
          }).$mount(n);
        }
      };
    },
        K = {
      install: function (e, t) {
        var n = 1 < arguments.length && void 0 !== t ? t : {};

        if (!e.prototype.$modal) {
          var i = new V(e, n);

          if (Object.defineProperty(e.prototype, "$modal", {
            get: function () {
              if (this instanceof e) {
                var t = this.$root;
                i.context.root || i.setDynamicModalContainer(t);
              }

              return i;
            }
          }), e.component(i.context.componentName, W), n.dialog) {
            var o = n.dialogComponentName || "VDialog";
            e.component(o, X);
          }
        }
      }
    },
        J = "__VERSION__";

    e.default = K;
  }], o.c = i, o.d = function (t, e, n) {
    o.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: n
    });
  }, o.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, o.t = function (e, t) {
    if (1 & t && (e = o(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (o.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var i in e) o.d(n, i, function (t) {
      return e[t];
    }.bind(null, i));
    return n;
  }, o.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return o.d(e, "a", e), e;
  }, o.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, o.p = "/dist/", o(o.s = 13);

  function o(t) {
    if (i[t]) return i[t].exports;
    var e = i[t] = {
      i: t,
      l: !1,
      exports: {}
    };
    return n[t].call(e.exports, e, e.exports, o), e.l = !0, e.exports;
  }

  var n, i;
});

/***/ })

}]);